import { getNextgenSettingsUrl } from '@jira/project-settings__get-settings-url/src/getClassicIssueLayoutSettingsUrl.tsx';
import {
	type ProjectType,
	SERVICE_DESK_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';

const getClassicSettingsUrl = (projectType: ProjectType, projectKey: string) =>
	projectType === SERVICE_DESK_PROJECT
		? `/jira/servicedesk/projects/${projectKey}/settings`
		: `/projects/${projectKey}/settings`;

export const getSettingsUrl = (
	projectType: ProjectType,
	isSimplified: boolean,
	projectKey: string,
): string =>
	!isSimplified || !projectType
		? getClassicSettingsUrl(projectType, projectKey)
		: getNextgenSettingsUrl(projectType, projectKey);
